<script setup lang="ts">


import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import {faLeftFromBracket} from "@fortawesome/pro-regular-svg-icons";
import {faShoppingCart} from "@fortawesome/pro-solid-svg-icons";
import {Button} from "@/shared/components/ui/button";
import CheckoutHeader from "@/checkout/components/CheckoutHeader.vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {useCheckoutStore} from "@/checkout/stores/checkout.store.ts";
import {useI18n} from "vue-i18n";

interface Props {
  title: string
  description: string
  icon: IconDefinition
}

defineProps<Props>()
const checkout = useCheckoutStore();
const {t} = useI18n()

const backToBasket = () => {
  window.document.location = checkout.config.basketReturn.url
}
</script>
<template>
  <CheckoutHeader :step="2">
    <a href="#" @click="backToBasket" class="text-slate-500 hover:text-gray-900">
      <FontAwesomeIcon :icon="faLeftFromBracket" class="mr-2"/>
      <span v-html="checkout?.config?.basketReturn?.label"/>
    </a>
  </CheckoutHeader>
  <div class="flex items-center justify-center w-screen h-screen">
    <div class="flex flex-col items-center space-y-4">
      <div class="m-default flex flex-col items-center">
        <h1 class="text-xl flex items-center space-x-2 mb-default">
          <FontAwesomeIcon :icon="icon" class="text-primary" size="2x"/>
          <span>{{ title }}</span>
        </h1>
        <p class="text-sm text-center" v-html="description"/>
      </div>
      <Button :icon="faShoppingCart" @click="backToBasket">{{ t('checkout.basket') }}</Button>
    </div>
  </div>
</template>
